"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RoyaltiesStatementsContentHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "Select your desired payee from the Payee drop-down menu. Then you can filter by distribution period and DSP in the corresponding drop-down menus."),
    react_1.default.createElement("p", null,
        "In the Select column, check the box(es) for any statements you would like to download or click",
        ' ',
        react_1.default.createElement("strong", null, " Select All "),
        " at the top of the column to select all statements."),
    react_1.default.createElement("p", null,
        "Scroll to the bottom and click",
        react_1.default.createElement("strong", null, " Continue to download"),
        ", then select your download options from the slide-out menu.")));
exports.default = RoyaltiesStatementsContentHeader;
